// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"283":"1e165082","309":"2ae057e4","674":"d8f295b5"}[chunkId] + ".chunk.js";
};